import { CSPUrl, LOGO_ID, CONTAINER_ID, HANDLE_ID } from './constants';

export const handleIframeFailure = (container: HTMLDivElement) => {
  // CSP container
  document.getElementById(HANDLE_ID)!.remove();
  document.getElementById(LOGO_ID)!.remove();
  document.getElementById(CONTAINER_ID)!.style.maxHeight = '236px';
  document.getElementById(CONTAINER_ID)!.style.height = '236px';
  document.getElementById(CONTAINER_ID)!.style.minHeight = '236px';
  document.getElementById(CONTAINER_ID)!.style.backgroundColor = 'rgb(247, 247, 247) !important';

  const CSPcontainer = document.createElement('div');
  CSPcontainer.classList.add('ab_csp_container');
  CSPcontainer.setAttribute('style', 'background:white; width:100%;font-family: Lato; height:100%;');
  CSPcontainer.innerHTML = `
    <div class="ab_csp_nav" style="box-sizing: border-box; box-shadow: 2px 2px 16px 0 rgba(0, 0, 0, 0.06);display:flex; justify-content:space-between;align-items:center; height:54px; width: 100%; padding:0 24px;"> 
        <div style="display:flex;align-items:center;">


<!-- AB TASTY LOGO  -->
        <svg height="32" width="32" version="1.1" id="Logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 110 110" style="enable-background:new 0 0 110 110;" xml:space="preserve">
        <style type="text/css">
            .st0{fill:url(#SVGID_1_);}
            .st1{fill:#FFFFFF;}
            .st2{opacity:0.42;fill:#FFFFFF;}
        </style>
        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-34.4104" y1="144.4104" x2="143.9523" y2="-33.9523">
            <stop  offset="0" style="stop-color:#006C8A"/>
            <stop  offset="0.25" style="stop-color:#217981"/>
            <stop  offset="0.5" style="stop-color:#009CB2"/>
            <stop  offset="0.75" style="stop-color:#00D4D4"/>
            <stop  offset="1" style="stop-color:#00F3F3"/>
        </linearGradient>
        <path class="st0" d="M107,55c0,28.7-23.3,52-52,52c-20.2,0-37.7-11.5-46.3-28.3L4.3,66.4C3.4,62.7,3,58.9,3,55C3,26.3,26.3,3,55,3
            S107,26.3,107,55z"/>
        <g>
            <polygon class="st1" points="50.4,78.7 37.7,78.7 36.7,74.5 48.1,69.4 	"/>
            <path class="st1" d="M38.6,31.3H28L4.3,66.4c0,0,0.6,2.8,1.8,6.3c1.3,3.5,2.6,6,2.6,6l7.6-11.2h18.7h12.7L38.6,31.3z M22.5,58.3
                l7.4-11l2.7,11H22.5z"/>
            <polygon class="st2" points="36.7,74.5 42.1,72.9 48.1,69.4 47.6,67.5 41.5,66.7 34.9,67.5 	"/>
            <polygon class="st2" points="56.1,65.8 62.1,64.1 68.5,60.3 68.8,58.3 62.9,57.4 57.5,58.3 	"/>
            <path class="st1" d="M92.6,53.3c-0.5-0.5-1.1-1.1-1.7-1.3c0.4-0.3,0.9-0.9,1.3-1.4c1.3-1.7,2.6-3.8,3-6.1c0.7-3.7-0.4-7.3-2.8-9.9
                c-2.3-2.4-5.4-3.4-10.2-3.4H62.2l-3.1,17.8h-8.6l2.3,9.2h4.7h11.4H79c3.4,0,4.5,1,5,1.8l0,0c0.8,1,1,2.3,0.8,3.7
                c-0.3,1.5-1,2.8-2.2,3.8c-1.4,1.3-3.2,1.9-5.8,1.9h-9.9l1.6-9.1l-12.3,5.5l-2.3,12.9H77c5.6,0,9.7-1.4,13.2-4.3
                c3.3-2.7,5-6.5,5.6-10.3C96.5,59.9,95.2,55.9,92.6,53.3z M84.3,44.7c-0.2,1-0.8,2.1-1.7,2.9c-0.9,0.8-2,1.5-4.8,1.5h-7.4l1.5-8.6
                h7.6c2.7,0,3.6,0.7,4.1,1.4C84.3,42.7,84.5,43.7,84.3,44.7z"/>
        </g>
        </svg>

        <span style="font-size: 14px; font-weight: 900; margin-left:6px">
        QA Assistant
        </span>
    </div>


    <!-- CLOSE BUTTON -->

    <svg onclick="document.getElementById('${CONTAINER_ID}').remove()" style="cursor:pointer" height="24" width="24" id="cricles_bg" data-name="cricles bg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Plan de travail 12v1</title><polygon points="18 7.49 16.51 6 12 10.51 7.49 6 6 7.49 10.51 12 6 16.51 7.49 18 12 13.49 16.51 18 18 16.51 13.49 12 18 7.49"/></svg>
    </div>
    <div class="ab_csp_body" style="display:flex;flex-direction:column; align-items:center; padding-top:23px;">

    <!-- exclamation SVG -->
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="40" viewBox="0 0 15 40" style="margin-bottom:23px;">
    <defs>
        <filter id="9gdxpk9cha" width="107.8%" height="140.3%" x="-3.8%" y="-23.1%" filterUnits="objectBoundingBox">
            <feOffset dy="-5" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g>
            <g filter="url(#9gdxpk9cha)" transform="translate(-712 -865) translate(0 788)">
                <g>
                    <path fill="#3C1A15" d="M2.5 25.001L5 25.001 5 12.501 2.5 12.501zM10 25.001L12.5 25.001 12.5 12.501 10 12.501zM0 12.501L2.5 12.501 2.5 2.501 0 2.501zM12.5 12.501L15.001 12.501 15.001 2.501 12.5 2.501zM5 27.501L10 27.501 10 25.001 5 25.001zM2.5 2.501L12.5 2.501 12.5 0 2.5 0zM5 32.501L10 32.501 10 30.001 5 30.001zM5 40.001L10 40.001 10 37.501 5 37.501zM2.5 37.501L5 37.501 5 32.501 2.5 32.501zM10 37.501L12.5 37.501 12.5 32.501 10 32.501z" transform="translate(712 77)"/>
                    <path fill="#CB3030" d="M5 37.501L10 37.501 10 35.001 5 35.001zM5 25.001L10 25.001 10 22.501 5 22.501zM7.5 22.501L10 22.501 10 12.501 7.5 12.501z" transform="translate(712 77)"/>
                    <path fill="#FF5252" d="M5 22.501L7.5 22.501 7.5 12.501 5 12.501z" transform="translate(712 77)"/>
                    <path fill="#CB3030" d="M10 12.501L12.5 12.501 12.5 2.501 10 2.501z" transform="translate(712 77)"/>
                    <path fill="#FF5252" d="M2.5 12.501L10 12.501 10 2.501 2.5 2.501zM7.5 35.001L10 35.001 10 32.501 7.5 32.501z" transform="translate(712 77)"/>
                    <path fill="#FF8282" d="M5 35.001L7.5 35.001 7.5 32.501 5 32.501zM5 7.501L7.5 7.501 7.5 2.501 5 2.501zM2.5 12.501L5 12.501 5 7.501 2.5 7.501z" transform="translate(712 77)"/>
                    <path fill="#F9B9B9" d="M2.5 7.501L5 7.501 5 2.501 2.5 2.501z" transform="translate(712 77)"/>
                </g>
            </g>
        </g>
    </g>
</svg>

    <span style="font-size:14px;line-height:1.29">We couldn’t open the QA Assistant probably due to the Content Security Policy configuration on your website.</span>
    <span style="font-size:14px;line-height:1.29">Please update the Content Security Policies of your website.</span>
        
    
    <a href="${CSPUrl}" rel="noopener noreferrer" style=" 
        width: 238px;
        height: 24px;
        margin: 8px 274px 0 273px;
        padding: 4px 15px 4px 16px;
        border-radius: 4px;
        border: solid 2px #007f91;
        color: #007f91;
        text-decoration: none;
        font-size: 13px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1.29;
        font-weight: bold;
        "
        target="_blank"
        >
      
        Open QA Assistant troubleshooting

    </a>
    </div>
  
  `;
  container.append(CSPcontainer);
};
